import React from "react"

export const DropDownArrow = () => (
  <i className="material-icons arrow_drop_down">arrow_drop_down</i>
)

export const DropUpArrow = () => (
  <i className="material-icons arrow_drop_up">arrow_drop_up</i>
)
